import React from 'react';

//icons
import { CrossmarkIcon } from 'assets/icons';

//styles
import { ClearFilterWrapper } from './ClearFilter.styled';
import { useTheme } from 'styled-components';

interface IClearFilter {
  fill?: string;
  onClick: () => void;
}

export const ClearFilter = ({ fill, onClick }: IClearFilter) => {
  const { colors } = useTheme();

  return (
    <ClearFilterWrapper onClick={onClick}>
      <CrossmarkIcon fill={fill ? fill : colors.black_10} />
    </ClearFilterWrapper>
  );
};
